// extracted by mini-css-extract-plugin
export const pageTitle = "page-module--pageTitle--3UjKF";
export const pageHeader = "page-module--pageHeader--2fcoS";
export const pageContent = "page-module--pageContent--3noMM";
export const page = "page-module--page--3cy2s";